/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVial: {
  name: 'vial';
  data: string;
} = {
  name: 'vial',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 .5a.5.5 0 0 0 0 1h.5V13a2.5 2.5 0 0 0 5 0V1.5h.5a.5.5 0 0 0 0-1H5Zm1.5 1V13a1.5 1.5 0 0 0 3 0V1.5h-3Z" fill="currentColor"/></svg>`,
};
